//закрываем popup
document.addEventListener('DOMContentLoaded', () => { 
    const popup=document.querySelector('.popup');
    const closeItem=document.querySelector('.close-popup');
    closeItem.addEventListener('click', () => {
    
        if(popup.classList.contains("open")){
            popup.classList.remove("open");
        }
    })        
})
